import { useState, useEffect, useRef } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export default function PreviewCustomerSelector({
  preparedRows,
  previewCustomerIdx,
  onPreviewCustomerChange,
}) {
  const measureRef = useRef(null);
  const [width, setWidth] = useState("auto");

  const options =
    preparedRows?.length > 1
      ? preparedRows.map((row, i) => ({
          value: i,
          label: row.customerName || row.reference || `Customer ${i + 1}`,
        }))
      : [];

  const selectedLabel = options[previewCustomerIdx]?.label ?? "";

  useEffect(() => {
    if (measureRef.current) {
      setWidth(`${measureRef.current.scrollWidth + 24}px`);
    }
  }, [selectedLabel]);

  if (!preparedRows || preparedRows.length <= 1) return null;

  return (
    <div className="shrink-0 flex items-center justify-center gap-1.5 pt-6 pb-1">
      <span
        ref={measureRef}
        aria-hidden
        className="invisible absolute whitespace-nowrap text-sm font-semibold"
      >
        {selectedLabel}
      </span>
      <span className="text-sm text-zinc-500">Previewing as</span>
      <label className="relative inline-flex items-center cursor-pointer">
        <select
          value={previewCustomerIdx}
          onChange={(e) => onPreviewCustomerChange(Number(e.target.value))}
          style={{ width }}
          className="appearance-none bg-transparent pr-4 text-sm font-semibold text-zinc-700 cursor-pointer focus:outline-none max-w-64 truncate"
        >
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDownIcon className="absolute right-0 size-3.5 text-zinc-500 pointer-events-none" />
      </label>
    </div>
  );
}
